import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { CheckboxField } from '@openx/components-core/lib/CheckboxField/CheckboxField';
import type { AttentionTargeting, VPVHTargeting } from '@openx/types/targeting/targeting';
import { useTranslation } from 'react-i18next';

type AttentionOverviewProps = {
  attention: AttentionTargeting;
  vpvh: VPVHTargeting;
};

export const AttentionOverview = ({ attention, vpvh }: AttentionOverviewProps) => {
  const { t } = useTranslation();

  return (
    <Box
      data-test="targeting-attention-overview"
      sx={{
        my: 2,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          width: '100%',
          mb: 1.5,
          display: 'flex',
          gap: 1,
        }}
      >
        {t('CTV Attention')}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <CheckboxField
          data-test="attention-checkbox"
          checked={attention === '1'}
          disabled={true}
          error={false}
          readOnly
          label={t('Target content with highly attentive audiences')}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <CheckboxField
          data-test="vpvh-checkbox"
          checked={vpvh === 'true'}
          disabled={true}
          error={false}
          readOnly
          label={t('Target segments with high likelihood of co-viewing')}
        />
      </Box>
    </Box>
  );
};
